<template>
  <div class='EnbSeoCard'>
    <div class="card">
      <div class="label" @click="$refs.arrow.run()">
        <div class="text-label">
          {{ label }}
          <div class="sub-label">Configure título, descrição, palavras-chave e thumbnail da página</div>
        </div>
        <div class="arrow" @click.stop>
          <arrow-icon ref="arrow" @showSubLinks="newValue => sublink = newValue"/>
        </div>
      </div>
      <div class="cont-input" :class="{ continput: sublink }">
        <div class="cont-i">
          <div class="cont-thumb">
            <div class="text-thumb">Thumbnail:</div>
            <input ref="inThumb" v-show="false" type="file" accept="image/png,image/jpeg,image/webp" @change="inThumb"/>
            <div class="cont-thumb-btn">
              <img v-if="thumbSrc" :src="thumbSrc" class="thumb-preview"/>
              <button @click="$refs.inThumb.click()">Selecione a imagem</button>
            </div>
          </div>
          <input-reg
          :value="Seo.titulo"
          text="Título"
          @update:modelValue="newValue => UpdateSeo('titulo', newValue)"
          :cont="{ textAlign: 'left' }"
          :label="{ marginLeft: '3px' }"
          :input="{ fontSize: '16px', padding: '10px 12px', width: '100%', boxSizing: 'border-box', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
          />
          <input-reg
          :value="Seo.descricao"
          text="Descrição"
          @update:modelValue="newValue => UpdateSeo('descricao', newValue)"
          :cont="{ textAlign: 'left', marginTop: '8px' }"
          :label="{ marginLeft: '3px' }"
          :input="{ fontSize: '16px', padding: '10px 12px', width: '100%', boxSizing: 'border-box', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
          />
          <input-reg
          :value="Seo.palavrachave"
          text="Palavra-chave"
          @update:modelValue="newValue => UpdateSeo('palavrachave', newValue)"
          :cont="{ textAlign: 'left', marginTop: '8px' }"
          :label="{ marginLeft: '3px' }"
          :input="{ fontSize: '16px', padding: '10px 12px', width: '100%', boxSizing: 'border-box', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InputReg from '@/components/EnbPainel/Produtos/Register/InputReg'
import ArrowIcon from '../Icons/ArrowIcon'
import api from '@/mixins/api'
export default {
  name: 'EnbSeoCard',
  components: { InputReg, ArrowIcon },
  mixins: [api],
  props: {
    comp: { type: String, required: true },
    label: { type: String, required: true }
  },
  data () {
    return {
      sublink: false
    }
  },
  computed: {
    ...mapGetters(['Prefes']),
    Seo () {
      return this.Prefes[this.comp] || {}
    },
    thumbSrc () {
      let img = this.Seo.img
      if (!img) return ''
      if (img.indexOf('base64,') !== -1) return img
      img = img.replace(/^\/+/, '')
      return process.env.NODE_ENV === 'production' ? '/' + img : this.api + img
    }
  },
  methods: {
    ...mapActions(['UpdatePrefComp']),
    UpdateSeo (prop, value) {
      this.UpdatePrefComp({ comp: this.comp, prop, value })
    },
    inThumb (e) {
      let file = e.target.files[0]
      if (!file) return
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.UpdateSeo('img', reader.result)
      }
      reader.onerror = (error) => {
        console.log('Error: ', error)
      }
      e.target.value = ''
    }
  }
}
</script>

<style scoped>
.EnbSeoCard {
  display: flex;
  margin-top: 5.8%;
}

.card {
  width: 100%;
  border: thin solid #CCCCCC;
  border-radius: 5px;
  overflow: hidden;
}

.label {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  background-color: #EEEEEE;
  color: #648EEA;
  font-size: 16px;
  text-align: left;
}

.text-label {
  width: 90%;
}

.text-label {
  padding: 2%;
}

.cont-input {
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.15s ease-out;
}

.continput {
  max-height: 1000px;
  transition: max-height 0.15s ease-in;
}

.cont-thumb {
  text-align: left;
  margin-bottom: 8px;
}

.sub-label {
  font-size: 12px;
  color: #888888;
  margin-top: 2px;
}

/* mesmo estilo do label do InputReg */
.text-thumb {
  margin-left: 3px;
  margin-bottom: 5px;
  font-size: 12px;
}

.cont-thumb-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
}

.thumb-preview {
  width: 80px;
  height: 42px;
  object-fit: cover;
  border: thin solid #CCCCCC;
  border-radius: 3px;
}

button {
  border: 0;
  background-color: #000000;
  color: #FFFFFF;
  border-radius: 5px;
  padding: 6px 10px;
  font-size: 14px;
  cursor: pointer;
}

input {
  margin-left: 2%;
}

.cont-i {
  padding: 2%;
}
</style>
